import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { SERVER_URL } from '../constants';
import { Stack } from '@mui/material';
import BasicTimePicker from './BasicTimePicker';
import { dateObjectToTimeString } from '../helpers/Helpers';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import { mysqlTimeToTimePickerDate } from '../helpers/Helpers';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Slider from '@mui/material/Slider';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function EditTodaysSchedule (props) {

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        fetchScheduleDetails();
        setOpen(true);
        setError("");
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const [startTime, setStartTime] = useState(dayjs(mysqlTimeToTimePickerDate(props.startTime)));
    
    const [endTime, setEndTime] = useState(dayjs(mysqlTimeToTimePickerDate(props.endTime)));

    const handleSave = () => {
        updateSchedule();
        handleClose();
    }

    const [serveMinutes, setServeMinutes] = useState(props.averageServeMinutes || 60);

    const [maxClients, setMaxClients] = useState(props.maxClients);

    // useEffect(() => {
    //     setServeMinutes(props.averageServeMinutes || 30);
    // }, [props.averageServeMinutes]);

    const handleChange = (event) => {
        const value = event.target.value;
        // Allow empty string or any number
        if (value === '' || /^\d+$/.test(value)) {
            setServeMinutes(value);
        }
    };

    const handleBlur = () => {
        const numericValue = Number(serveMinutes);
        if (numericValue < 5) {
            setServeMinutes(5);
        } else if (numericValue > 120) {
            setServeMinutes(120);
        }
    };

    const handleMaxClientsChange = (event) => {
        const { value } = event.target;

        // Allow empty string so user can clear the field
        if (value === "") {
            setMaxClients("");
            return;
        }

        const numericValue = Number(value);

        // Clamp only if not empty
        setMaxClients(numericValue < 1 ? 1 : numericValue);
    };

    const handleSliderChange = (event, newValue) => {
        setServeMinutes(newValue);
    };

    const [error, setError] = useState("");
    
    const handleStartChange = (newValue) => {
        setStartTime(newValue);
        if (endTime && newValue.isAfter(endTime)) {
            setError("Closing Time must be later than Opening Time");
        } else {
            setError("");
        }
    };

    const handleEndChange = (newValue) => {
        setEndTime(newValue);
        if (startTime && newValue.isBefore(startTime)) {
            setError("Closing Time must be later than Opening Time");
        } else {
            setError("");
        }
    };

    const fetchScheduleDetails = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/detail-schedule/' + props.scheduleId, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log("schedule data.data", data.data);
            setStartTime(dayjs(mysqlTimeToTimePickerDate(data.data.start_time)));
            setEndTime(dayjs(mysqlTimeToTimePickerDate(data.data.end_time)));
            setServeMinutes(data.data.average_serve_minutes);
            setMaxClients(data.data.max_clients);
        })
        .catch(err => console.error(err));
    }


    const updateSchedule= () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/update-schedule/' + props.scheduleId,
        {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "start_time": dateObjectToTimeString(new Date(startTime)),
                "end_time": dateObjectToTimeString(new Date(endTime)),
                "average_serve_minutes": serveMinutes,
                "max_clients": maxClients
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                if (typeof props.fetchOffices === 'function') {
                    props.fetchOffices();
                }
                if (typeof props.fetchSchedulesList === 'function') {
                    props.fetchSchedulesList(dayjs(props.rawDate));
                }
                props.fetchScheduleDetails(props.scheduleId);
            }
        })
        .catch(err => console.error(err))
    }

    return(
        <React.Fragment>
            <IconButton
                    onClick={handleClickOpen}
                    size="medium"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
            <RoomPreferencesIcon fontSize='large' sx={{ color: 'gray' }} />
            </IconButton>
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",  // Set your width here
                    },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0}
                    >
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        Business Hours<br /> {props.date} 
                        </Typography>
                        <Typography variant="body1">
                        {props.officeName}
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <Stack spacing={2}>
                        <BasicTimePicker value={startTime} onChange={handleStartChange} label="Opening Time (visible to clients)" ampm={true} minutesStep={5} />                      
                        <BasicTimePicker value={endTime} onChange={handleEndChange} label="Closing Time (visible to clients)" ampm={true} minutesStep={5} />
                        {error && (
                            <Typography variant="body2" color="error" sx={{ mt: 0 }}>
                            {error}
                            </Typography>
                        )}
                        {!props.hideMaxClients ? 
                        <Typography variant="body2">
                            Service Velocity adjusts automatically based on actual queue speed. You can override it here temporarily. (Not recommended)
                        </Typography>
                        : null}
                        <TextField
                            type="number"
                            name="serveMinutes"
                            value={serveMinutes}
                            id="outlined-multiline-static"
                            label="Service Velocity in Minutes"
                            InputProps={{ inputProps: { min: 5, max: 120 } }}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {!props.hideMaxClients ? 
                        <TextField
                            type="number"
                            name="maxClients"
                            value={maxClients}
                            id="outlined-multiline-static"
                            label="Max Clients"
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ min: 1 }} 
                            onChange={handleMaxClientsChange}
                        />
                        : null}

                        
                        {/* <Box sx={{ m: 0, p: 1 }}>
                            <Slider
                            value={serveMinutes}
                            aria-label="Service Velocity"
                            valueLabelDisplay="auto"
                            min={1}
                            max={120}
                            onChange={handleSliderChange}
                            />
                        </Box> */}

                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} >Cancel</Button>
                    <Button disabled={error !== "" ? true : false} onClick={handleSave} >Save</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default EditTodaysSchedule;